import { Dialog, ExclamationCircleFilled } from '@fx-ui/fine-design';
import React from 'react';
import Intl from '@fx-ui/intl';

interface McpAgreementDialogProps {
    visible: boolean;
    onAgree: () => void | Promise<void>;
    onReject: () => void;
}

/**
 * MCP 服务开启协议弹窗。
 */
const McpAgreementDialog: React.FC<McpAgreementDialogProps> = ({ visible, onAgree, onReject }) => {
    return (
        <Dialog
            className="fx-mcp-agreement-dialog"
            classNames={{
                body: 'mcp-agreement-body',
                footer: 'mcp-agreement-footer'
            }}
            visible={visible}
            title={Intl.get('fxp.base.bg.corp_config.ai_access_enabling_agreement.ttl')}
            width={640}
            styles={{
                wrapper: {
                    height: 'auto'
                }
            }}
            contentPadding={false}
            text4Cancel={null}
            text4Ok={Intl.get('fxp.base.bg.corp_config.enable.btn')}
            footer={
                <span className="agreement-footer-tip">
                    {Intl.get('fxp.base.bg.corp_config.enabling_means_aware_of_risks.tip')}
                </span>
            }
            onOk={onAgree}
            onCancel={onReject}
        >
            <div className="agreement-intro">
                <ExclamationCircleFilled className="agreement-intro-icon" />
                <div className="agreement-intro-text">
                    {Intl.get('fxp.base.bg.corp_config.ai_access_enabling_agreement.tip1')}
                </div>
            </div>
            <ul className="agreement-clauses">
                <li>{Intl.get('fxp.base.bg.corp_config.ai_access_enabling_agreement.tip2')}</li>
                <li>{Intl.get('fxp.base.bg.corp_config.ai_access_enabling_agreement.tip3')}</li>
                <li>{Intl.get('fxp.base.bg.corp_config.ai_access_enabling_agreement.tip4')}</li>
                <li>{Intl.get('fxp.base.bg.corp_config.ai_access_enabling_agreement.tip5')}</li>
            </ul>
        </Dialog>
    );
};

export default McpAgreementDialog;
